import React from 'react';

export function VirtualAccountToggle({ checked, onChange, label = 'Use Virtual Account for verification' }) {
  return (
    <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        style={{ marginRight: 5 }}
      />
      <span style={{ fontSize: 13 }}>{label}</span>
    </label>
  );
} 